import { AuthMeResponse } from 'src/app/core/auth-me/auth-me.models';
import { canViewWorkflowFeature } from 'src/app/features/response-orchestrations/workflows/workflow.models';

export const OUTBOUND_LIMIT_ZERO_MSG =
  'You cannot add any Outbound Mapping Rules under your current account level. If you need to add your own custom rules, please upgrade to the next level of service offering or contact us at support@alertops.com';

export const OUTBOUND_LIMIT_MAX_MSG =
  'You have reached the maximum allowed Outbound Mapping Rules for your account. If you need to add more rules, please upgrade to the next level of service offering or contact us at support@alertops.com';

/** Old UI: GET /app/limits/outboundintegration */
export function resolveOutboundCreateLimit(
  rows: { maximum?: number; current?: number }[] | null | undefined,
): { allowed: boolean; tooltip: string } {
  const row = rows?.[0];
  if (!row) {
    return { allowed: true, tooltip: '' };
  }
  if (row.maximum === -99) {
    return { allowed: true, tooltip: '' };
  }
  if (row.maximum != null && row.current != null && row.current >= row.maximum) {
    const tooltip = row.maximum === 0 ? OUTBOUND_LIMIT_ZERO_MSG : OUTBOUND_LIMIT_MAX_MSG;
    return { allowed: false, tooltip };
  }
  return { allowed: true, tooltip: '' };
}

/** Matches old UI: show outbound section when (maintenance OR integrations_view) AND outbound_api. */
export function canViewOutbound(authMe: AuthMeResponse | null | undefined): boolean {
  const c = authMe?.capabilities;
  if (!c) return false;
  if (!c.packageFeatures?.outboundApi) return false;
  if (c.integrations?.canManageOutbound) return true;
  if (c.integrations?.canView) return true;
  return false;
}

/** Matches old UI disable expression for outbound maintenance actions. */
export function canMaintainOutbound(authMe: AuthMeResponse | null | undefined): boolean {
  const c = authMe?.capabilities;
  return c?.packageFeatures?.outboundApi === true
    && c.integrations?.canManageOutbound === true;
}

/** Settings, headers, clone, delete — blocked on bidirectional integrations (old UI). */
export function canEditOutboundStructure(
  authMe: AuthMeResponse | null | undefined,
  isBidirection: boolean,
): boolean {
  return canMaintainOutbound(authMe) && !isBidirection;
}

/** Header Edit on method card — bidirectional allows URI-only edit (ConnectWise). */
export function canEditOutboundSettings(
  authMe: AuthMeResponse | null | undefined,
): boolean {
  return canMaintainOutbound(authMe);
}

/** Request/response body — still editable on bidirectional integrations (old UI). */
export function canEditOutboundPayload(authMe: AuthMeResponse | null | undefined): boolean {
  return canMaintainOutbound(authMe);
}

export function canLinkWorkflows(authMe: AuthMeResponse | null | undefined): boolean {
  const c = authMe?.capabilities;
  if (!c) return false;
  return canViewWorkflowFeature(authMe);
}

export function canLinkEscalationPolicies(authMe: AuthMeResponse | null | undefined): boolean {
  const c = authMe?.capabilities;
  return c?.appConfig?.canViewRules === true;
}
